export default __webpack_public_path__ + "static/media/reset.button.eb979e93.svg";